import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import { getInsUserMediaById } from "@/api/http/ins/insUser";
import { getUserFeed, getUserFeedMore } from "@/api/http/ins/web/webUserInfo";
import { postMediaEnableComments } from "@/api/http/ins/insMedia";
import generalUtilsHelper from "@/utils/generalUtils";
import EventBus from "@/utils/eventBus";

let hasUpdateUserPostMedia: boolean = false;

const actions: ActionTree<any, any> = {
  async [types.UPDATE_USER_INS_POST](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      console.log("UPDATE_USER_INS_POST");
      //再拉取insUser, insMedia, gxUserInfo信息：
      let insUserMedia: any;
      //当前用户的类型：

      // if (getters[types.GETTER_CURRENT_INS_USER_INFO].userType === "search") {
      //   insUserMedia = await getUserFeed(payload, true);
      // } else {
      // insUserMedia = await getInsUserMediaById(payload);
      // }
      insUserMedia = await getInsUserMediaById(payload);
      commit(types.RECEIVE_INS_USER_MEDIA_LIST_DATA, {
        userId: payload,
        insUserMedia
      });
      if (
        insUserMedia.hasOwnProperty("items") &&
        insUserMedia.items.length !== 0
      ) {
        //如果items的数量不为0，需要更新当前的media_id
        //更新post_id:
        const currentPostId = getters[types.GETTER_CURRENT_INS_POST_ID];
        const findCurrentPostId = insUserMedia.items.find((item: any) => {
          return item.id === currentPostId;
        });
        if (!findCurrentPostId) {
          commit(types.CHANGE_CURRENT_INS_POST_ID, insUserMedia.items[0]);
        }

        //更新view_id:
        const findView = insUserMedia.items.find((item: any) => {
          return item.media_type === 2;
        });
        if (findView === undefined || findView === null) {
          //如果当前页没有view
          commit(types.CHANGE_CURRENT_INS_VIEW_ID, null);
        } else {
          const currentViewId = getters[types.GETTER_CURRENT_INS_VIEW_ID];
          const findCurrentViewId = insUserMedia.items.find((item: any) => {
            return item.id === currentViewId;
          });
          if (!findCurrentViewId) {
            commit(types.CHANGE_CURRENT_INS_VIEW_ID, findView);
          }
        }
      } else {
        commit(types.CHANGE_CURRENT_INS_VIEW_ID, null);
        commit(types.CHANGE_CURRENT_INS_POST_ID, null);
      }
    } catch (error) {
      console.log("UPDATE_USER_INS_POST error:", error);
      return Promise.reject(error);
    }
  },
  async [types.REQUEST_INS_USER_MEDIA_LIST_DATA_MORE](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      //判断是否有更多:
      const findMedia = state.insUserMediaList.find((item: any) => {
        return item.userId === payload;
      });
      if (findMedia !== undefined && findMedia.moreAvaliable) {
        let insUserMedia: any;
        //当前用户是搜索用户，就用web接口，是login用户就用私有api
        // if (getters[types.GETTER_CURRENT_INS_USER_INFO].userType === "search") {
        //   insUserMedia = await getUserFeedMore(payload, findMedia.maxMediaId);
        // } else {
        //   insUserMedia = await getInsUserMediaById(
        //     payload,
        //     findMedia.maxMediaId
        //   );
        // }
        insUserMedia = await getInsUserMediaById(payload, findMedia.maxMediaId);
        commit(types.RECEIVE_INS_USER_MEDIA_LIST_DATA_MORE, {
          userId: payload,
          insUserMedia
        });

        //如果当前的current view的id是null的话，更新当前页有的view id:
        //更新view_id:、
        if (!getters[types.GETTER_CURRENT_INS_VIEW_ID]) {
          const findView = insUserMedia.items.find((item: any) => {
            return item.media_type === 2;
          });
          if (findView === undefined || findView === null) {
            //如果当前页没有view
            commit(types.CHANGE_CURRENT_INS_VIEW_ID, null);
          } else {
            commit(types.CHANGE_CURRENT_INS_VIEW_ID, findView);
          }
        }

        return insUserMedia;
      } else {
        //没有更多
        return false;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.ENABLE_POST_COMMENT]({ state, commit, dispatch }, payload: any) {
    try {
      const { mediaId, userId } = payload;
      const result: any = await postMediaEnableComments(mediaId, userId);
      console.log("postMediaEnableComments：result:", result);
      if (result.status && result.status === "ok") {
        commit(types.UPDATE_POST_DISABLE_COMMENT, {
          mediaId,
          userId
        });
        return result;
      } else {
        return Promise.reject("");
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.NEED_UPDATE_USER_INS_POST](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      if (!generalUtilsHelper.isEmptyAccount() && !hasUpdateUserPostMedia) {
        const currentUserInfo = getters[types.GETTER_CURRENT_INS_USER_INFO];
        dispatch(types.UPDATE_USER_INS_POST, currentUserInfo.userId);
        hasUpdateUserPostMedia = true;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default actions;
